import { IFormatter } from '../FormatterTypes';
import { TEDDisplayTime } from '../Displayers/TEDDisplayTime';
import { TEDParseTime } from '../Parsers/TEDParseTime';
import { TEDValidateDefault } from '../Validators/TEDValidateDefault';

class TEDFormatTime implements IFormatter {
  displayer = TEDDisplayTime.getInstance();
  parser = TEDParseTime.getInstance();
  validator = TEDValidateDefault.getInstance();
}

export { TEDFormatTime };
